export const load = () => ({
	title: 'Insulating Specialty Shaped Windows',
	h1: 'Window Inserts For Specialty Shaped Windows',
	description:
		"Indow's custom-shaped window inserts are the perfect solution for blocking drafts, noise, and more in uniquely shaped windows.",
	showTitle: true,
});
